import { useCallback, useEffect, useState } from 'react'

import { Subscription } from 'centrifuge'

import { WebSocketInstance } from '../types'
import { UseWebSocketSubscribeParams } from './types'
import { useWebSocket } from './useWebSocket'
import { initializeSubscription } from './utils'

export function useWebSocketSubscribe<TResponse>({ channel, multi }: UseWebSocketSubscribeParams) {
  const [value, onPublication] = useState<TResponse>()
  const [webSocketInstance, setWebSocket] = useState<WebSocketInstance>()
  const [currentSubscription, setCurrentSubscription] = useState<Subscription | null>(null)
  const context = useWebSocket()

  const publish = useCallback(
    (data: any) => {
      if (currentSubscription) {
        currentSubscription.publish(data)
      }
    },
    [currentSubscription],
  )

  useEffect(() => {
    const establishConnectionWithWebSocket = async () => {
      const webSocket = await context.getWebSocketInstance()

      setWebSocket(webSocket)
    }

    establishConnectionWithWebSocket()
  }, [])

  useEffect(() => {
    if (webSocketInstance) {
      const subscription = initializeSubscription({ webSocketInstance, channel, onPublication, multi })
      setCurrentSubscription(subscription)

      return () => {
        setCurrentSubscription(null)
        webSocketInstance.removeSubscription(subscription)
      }
    }

    return undefined
  }, [webSocketInstance])

  return { value, publish }
}
